import React from 'react';
import { Link } from 'react-router-dom';
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown';
import { observer } from 'mobx-react';
import img from "../../../../public/static/img/logo-white.png"
import checkoutImg from '../../img/check-out.png';
// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import Help from '../Help/Help';

const Header = observer(class Header extends React.Component {
  constructor(props) {
    super();

    // Bind this to functions
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.toggleNav = this.toggleNav.bind(this);
    this.renderPoliciesButton = this.renderPoliciesButton.bind(this);
  }

  componentWillMount() {
    this.state = {
      navOpen: false,
      activePage: ''
    }

    this.props.store.SessionStore.getUnreadCount();
  }

  handleLinkClick() {
    const dropdowns = [];
    dropdowns.push(this.refs.pagesDropdown);
    dropdowns.push(this.refs.accountDropdown);
    for(var i = 0; i < dropdowns.length; i++) {
      if(typeof dropdowns[i] !== 'undefined') {
        dropdowns[i].hide();
      }
    }
    this.setState({
      navOpen: false
    });
  }

  toggleNav(e) {
    e.preventDefault();
    this.setState({
      navOpen: !this.state.navOpen
    });
  }

  isActive(url) {
    if(url === this.props.routing.location.pathname) {
      return true;
    } else {
      return false;
    }
  }

  renderPoliciesButton() {
    const { translation } = this.props;

    return (
      <li>
        <Link
          className={`navbar__item ${this.isActive('policies') ? 'navbar__item--active' : ''}`}
          to="/policies"
          onClick={this.handleLinkClick}
        >
          <icons.iconClipboard />
          {translation.navigation.policies}
        </Link>
      </li>
    )
  }

  renderHybrid = () => {
    const { translation, store } = this.props;
    const { HybridStore, SessionStore } = store;
    const { checkoutSessionCount, listCheckoutSessions } = HybridStore;
    const { enableHybridCheckout } = SessionStore.account;

    if (enableHybridCheckout) {
      listCheckoutSessions(1);
      setInterval(() => listCheckoutSessions(1), 60000);

      return (
        <React.Fragment>
          <li>
            <Link
                className={`navbar__item ${this.isActive('/hybrid-proctoring') ? 'navbar__item--active' : ''}`}
                to="/hybrid-proctoring"
                onClick={this.handleLinkClick}
            >
              <icons.iconEye />
              {translation.navigation.hybrid_proctoring}
            </Link>
          </li>
          <li>
            <Link
              className={`navbar__item notification-anchor ${this.isActive('/checkout') ? 'navbar__item--active' : ''}`}
              to="/checkout"
            >
              <img src={checkoutImg} className='icn' alt='Checkout queue'/>
              {translation.navigation.checkout_queue}

              {checkoutSessionCount > 0 &&
                <span className="notification__count badge">{checkoutSessionCount}</span>
              }
            </Link>
          </li>
        </React.Fragment>
      )
    } else {
      return (
        <li>
          <Link
              className={`navbar__item ${this.isActive('/hybrid-proctoring') ? 'navbar__item--active' : ''}`}
              to="/hybrid-proctoring"
              onClick={this.handleLinkClick}
          >
            <icons.iconEye />
            {translation.navigation.hybrid_proctoring}
          </Link>
        </li>
      )
    }
  }

  render() {
    let openClass = null;
    let menuText = 'Menu';

    if(this.state.navOpen) {
      openClass = 'open';
      menuText = 'Close';
    } else {
      menuText = 'Menu';
    }

    const { translation, store } = this.props;
    const { SessionStore } = store;
    const { userData } = SessionStore;

    return(
      <header className="site-head wrap">
        {!this.props.hideNav &&
          <a href="'/'" className={`nav-btn ${openClass}`} onClick={this.toggleNav}><span className="meta">{menuText}</span></a>
        }

        <h1 className="meta">SmarterProctoring</h1>

        {!this.props.hideNav &&
          <Link className="branding" to="/">
            <img src={img} width="191" alt="SmarterProctoring" />
          </Link>
        }

        {this.props.hideNav &&
          <span className="branding">
            <img src={img} width="191" alt="SmarterProctoring" />
          </span>
        }

        {this.props.hideNav &&
          <ul className="account-menu dropdown">
            <li>
              <Help
                btnClass="account-menu__item"
                {...this.props}
              />
            </li>
          </ul>
        }

        {userData && !this.props.hideNav &&
          <ul className="account-menu dropdown" aria-haspopup="true">
            <li>
              <Dropdown ref="accountDropdown">
                <DropdownTrigger className="dropdown__trigger" aria-controls="#nav-account">
                  <abbr
                    className={`avatar--initials ${userData.firstName.charAt(0).toLowerCase()}`}
                    title={userData.firstName}
                  >
                    {userData.firstName.charAt(0)}
                  </abbr>
                  <span className="account-menu__name">{userData.firstName}</span>
                </DropdownTrigger>

                <DropdownContent>
                  <ul id="nav-pages" className="dropdown__menu" role="menu" aria-hidden="true">
                    <li>
                      <Link className="dropdown__item" to="/settings" onClick={this.handleLinkClick}>{translation.navigation.account.settings}</Link>
                    </li>
                    <li className="dropdown__separated">
                      <a className="dropdown__item" href="#" onClick={() => {SessionStore.logout(this.props.routing.history)}}>{translation.navigation.account.sign_out}</a>
                    </li>
                  </ul>
                </DropdownContent>
              </Dropdown>
            </li>
            <li className="separator">
              <Help
                btnClass="account-menu__item"
                {...this.props}
              />
            </li>
          </ul>
        }

        {!this.props.hideNav &&
          <nav id="nav" className={`navbar ${openClass}`} role="menubar">
            <h2 className="meta">{translation.navigation.heading}</h2>

            <ul className="navbar__menu">
              <li>
                <Link className={`navbar__item ${this.isActive('/') ? 'navbar__item--active' : ''}`} to="/" onClick={this.handleLinkClick}>
                  <icons.iconDashboard />
                  {translation.navigation.dashboard}
                </Link>
              </li>
              <li>
                <Link className={`navbar__item notification-anchor ${this.isActive('/messages') ? 'navbar__item--active' : ''}`} to="/messages" onClick={this.handleLinkClick}>
                  <icons.iconEnvelope />
                  {translation.navigation.messages}

                  {SessionStore.unreadCount > 0 &&
                    <span className="notification__count badge">{SessionStore.unreadCount}</span>
                  }
                </Link>
              </li>
              <li>
                <Link
                  className={`
                    navbar__item
                    ${this.isActive('/sessions') ? 'navbar__item--active' : ''}
                    ${this.isActive('/pending-sessions') ? 'navbar__item--active' : ''}
                  `}
                  to="/sessions"
                  onClick={this.handleLinkClick}
                >
                  <icons.iconClock />
                  {translation.navigation.sessions}
                </Link>
              </li>
              <li>
                <Link className={`navbar__item ${this.isActive('/locations') ? 'navbar__item--active' : ''}`} to="/locations" onClick={this.handleLinkClick}>
                  <icons.iconMapMarker />
                  {translation.navigation.locations}
                </Link>
              </li>
              {SessionStore.userData.isSuperAdmin && SessionStore.smarterscheduling &&
                <li>
                  <Link className={`navbar__item ${this.isActive('/calendars') ? 'navbar__item--active' : ''}`} to="/calendars" onClick={this.handleLinkClick}>
                    <icons.iconCalendar />
                    {translation.navigation.calendars}
                  </Link>
                </li>
              }
              <li>
                <Link className={`navbar__item ${this.isActive('/payments') ? 'navbar__item--active' : ''}`} to="/payments" onClick={this.handleLinkClick}>
                  <icons.iconUSD />
                  {translation.navigation.payments}
                </Link>
              </li>
              <FeatureFlag
                flagKey="proctor-cancellation-policies"
                renderFeatureCallback={this.renderPoliciesButton}
              />
              <li>
                <Link className={`navbar__item ${this.isActive('/reports') ? 'navbar__item--active' : ''}`} to="/reports" onClick={this.handleLinkClick}>
                  <icons.iconGraph />
                  {translation.navigation.reports}
                </Link>
              </li>
              {SessionStore.userData.isSuperAdmin &&
               <li>
                <Link className={`navbar__item ${this.isActive('/users') ? 'navbar__item--active' : ''}`} to="/users" onClick={this.handleLinkClick}>
                  <icons.iconPerson />
                  {translation.navigation.users}
                </Link>
              </li>
              }
              <FeatureFlag
                  flagKey="hybrid"
                  renderFeatureCallback={this.renderHybrid}
              />
            </ul>
          </nav>
        }
      </header>
    );
  }
})

export default translate('Header')(Header);



// WEBPACK FOOTER //
// ./src/app/components/Common/Header.js